/**
 * Prefetch Nav Item Urls
 * @description A simple nav prefetch to improve UX speed for primary pages
 */
const preFetch = () => {

    // Cancel for splash because sign up and login do not exist
    if (window.dssMlpConfigs && window.dssMlpConfigs.variant === 'splash') {
        return;
    }

    const prefetchSlugs = ['/sign-up', '/login'];
    const head = document.getElementsByTagName('head')[0];
    let i;

    for (i = 0; i < prefetchSlugs.length; i++) {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = window.location.origin + prefetchSlugs[i];
        head.appendChild(link);
    }
};

/**
 * Convert Nodelists into arrays
 * @description //Polyfill to turn nodelists into arrays for IE
 */
const convertNodes = () => {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg = window) {
            for (let i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
};


/**
 * @description Returns whether the urlLang is a valid locale format
 * @param {String} urlLang - language from URL
 * @returns {Boolean} True if contextUrlPrefix is a valid config combination
 * Example valid matches en, de, en-gb, en-us, fr-fr
 */
const isValidLocaleFormat = (urlLang = '') => {
    return /^[a-zA-Z]{2}(-[a-zA-Z0-9]{2,3})?$/.test(urlLang);
};


/**
 * Replace the current language string with a new one
 * @param {string} originalUrl
 * @param {string} lang
 * @param {string} newLang
 * @return {string}
 */
const replaceLanguageInPathname = (pathname, newLang) => {
    const parts = pathname.slice(1).split('/');
    if (parts.length > 1 && isValidLocaleFormat(parts[0])) {
        if (newLang === 'en') {
            parts.shift();
        } else {
            parts[0] = newLang;
        }
    } else {
        parts.unshift(newLang);
    }

    return `/${parts.join('/')}`;
};

/**
 * @description Adds tracking attributes to rich text links
 */
const setupRichTextForTracking = () => {
    document.querySelectorAll('.hero .richtext a').forEach(el => {
        el.setAttribute('data-gv2-element', 'element');
        el.setAttribute('data-gv2-key', 'button');
        el.setAttribute('data-analytics', 'click');
        el.setAttribute('data-analytics-name', el.textContent);
    });
};

module.exports = {
    isValidLocaleFormat,
    preFetch,
    convertNodes,
    replaceLanguageInPathname,
    setupRichTextForTracking
};
